import { useEffect, useMemo } from 'react';
import { useCountdown } from 'usehooks-ts';
import DurationDisplay from '@/components/common/duration-display';
import type { ConversationMessageTypeUnion } from '@/models/conversations/conversation';

interface Props {
  message: ConversationMessageTypeUnion;
}

export default function MessageDecoratorBurnTimer({ message }: Props) {
  const { ReadDelete, ReadStamp, AutoDeleteTime, IsRead } = message;

  const countStart = useMemo(() => {
    if (!ReadStamp || !AutoDeleteTime) return 0;
    return Math.floor((ReadStamp + AutoDeleteTime * 1000 - Date.now()) / 1000);
  }, [ReadStamp, AutoDeleteTime]);

  const [countDown, { startCountdown, stopCountdown, resetCountdown }] = useCountdown({
    countStart,
    countStop: 0,
    intervalMs: 1000,
  });

  useEffect(() => {
    if (ReadDelete && IsRead && ReadStamp) {
      resetCountdown();
      startCountdown();
    }

    return () => stopCountdown();
  }, [IsRead, ReadDelete, ReadStamp]);

  if (!IsRead || !ReadDelete) return null;

  return (
    <DurationDisplay
      duration={countDown}
      className='text-xs text-primary'
    />
  );
}
